import { useState } from "react";
import BioForm from "./BioForm";
import Reveal from "@/components/base/Reveal";

export default function BioCTA() {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <section className="py-20 md:py-28 px-4 relative overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[400px] rounded-full glow-orb blur-3xl opacity-30 pointer-events-none"></div>

        <div className="relative z-10 max-w-lg mx-auto text-center">
          <Reveal>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
              Sua próxima fonte de tráfego está a um clique.
            </h2>
            <p className="text-foreground-600 mb-8">
              Pare de depender de um único canal. Descubra o potencial do Kwai Ads para sua operação.
            </p>

            <button
              onClick={() => setShowForm(true)}
              className="w-72 sm:w-80 inline-flex items-center justify-center gap-2.5 rounded-xl px-6 py-4 text-sm font-bold tracking-wide text-background-50 bg-gradient-to-r from-primary-500 to-accent-500 animate-pulse-glow-btn transition-transform hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              QUERO MINHA BM AGORA
            </button>

            <p className="text-xs text-foreground-500 mt-6">
              kwai.ads é uma operação independente de gestão de mídia.
            </p>
          </Reveal>
        </div>
      </section>

      {showForm && <BioForm onClose={() => setShowForm(false)} />}
    </>
  );
}